module.exports = __webpack_public_path__ + "img/innovativeCircuits.9b115031.svg";